import { useProfile } from '@mint-lib/profile-helpers';
import { useFlags } from '@mint-lib/routing-context';

const useRedmillUser = () => {
  const ff = useFlags('@mint/arm', ['aiRedmillUser']);
  const { profileService } = useProfile();
  return {
    isRedmillUser: profileService.isRedmillUser() && ff.aiRedmillUser.enabled,
  };
};

export { useRedmillUser };
